import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, LANGUAGES, type Language } from 'src/lib/i18n/language';
import en from 'src/locales/en.json';
import ru from 'src/locales/ru.json';

export const resources = {
  ru: { translation: ru },
  en: { translation: en },
} as const;

export const createI18n = (language: Language) => {
  const instance = i18next.createInstance();

  instance.on('languageChanged', (next) => {
    document.documentElement.lang = next;
  });

  void instance.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGES,
    interpolation: { escapeValue: false },
  });

  return instance;
};
